import PropTypes from 'prop-types'
import classNames from 'classnames'

import iconPaths from './iconPaths.js'
import symIconPaths from './symIconPaths.js'

const allIconPaths = {...iconPaths, ...symIconPaths}

export default function Icon({name, className, title, ...rest}) {
  const entry = allIconPaths[name]

  if (!entry) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`Icon: unknown icon name "${name}"`)
    }
    return null
  }

  // System 1 icons are plain strings, System 2 icons are {d, viewBox, ascent}
  const isObject = typeof entry === 'object'
  const pathData = isObject ? entry.d : entry
  const viewBox = isObject ? entry.viewBox : '0 0 512 512'
  const ascent = isObject ? entry.ascent : 480
  const noFlip = isObject && entry.noFlip
  const fillRule = isObject ? entry.fillRule : undefined

  return (
    <svg
      className={classNames('icon-svg', className)}
      viewBox={viewBox}
      fill="currentColor"
      aria-hidden={title ? undefined : 'true'}
      role={title ? 'img' : undefined}
      {...rest}
    >
      {title && <title>{title}</title>}
      {noFlip ? (
        <path d={pathData} fillRule={fillRule} />
      ) : (
        <g transform={`translate(0, ${ascent}) scale(1, -1)`}>
          <path d={pathData} fillRule={fillRule} />
        </g>
      )}
    </svg>
  )
}

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
}
